import React from "react";
import SpeechDemo from "./raw/SpeechDemo";
// import SpeechRecognition, {
//   useSpeechRecognition,
// } from "react-speech-recognition";

function Speech(props) {
  return (
     <section className="speech-section">

     </section>
    // <>
    //   {/* <SpeechDemo /> */}
    // </>
  );
}

export default Speech;
